import { createContext } from "react";

export const NotificationContext = createContext({})
export const WARNING = 'warning'
export const ERROR  = 'error'
export const SUCCESS = 'success'
export const INFO = 'info'